<template>
  <div class="loader">
    <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="loader__circular"
    ></v-progress-circular>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
@use '../../../assets/scss/variables';

  .loader {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
    background-color: variables.$color-white-a4;
  }
</style>
